import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'app/core/services/local-storage.service';
import { map } from "rxjs/operators";

@Component({
  moduleId: module.id,
  selector: 'fixedplugin-cmp',
  templateUrl: 'fixedplugin.component.html'
})

export class FixedPluginComponent implements OnInit {
  public settings: Settings = {} as Settings;
  public sidebarColor: string = "white";
  public sidebarActiveColor: string = "danger";
  public ethAddress: string;
  public state: boolean = true;
  private sidebar: HTMLElement;

  constructor(private localStorageService: LocalStorageService, private httpClient: HttpClient) {

  }
  changeSidebarColor(color: string) {
    this.sidebarColor = color;
    if (this.sidebar != undefined) {
      this.sidebar.setAttribute('data-color', color);
      this.settings.sidebarColor = color;
      this.localStorageService.setInfo(this.settings);
    }
  }
  changeSidebarActiveColor(color: string) {
    this.sidebarActiveColor = color;
    if (this.sidebar != undefined) {
      this.sidebar.setAttribute('data-active-color', color);
      this.settings.sidebarActiveColor = color;
      this.localStorageService.setInfo(this.settings);
    }
  }
  ngOnInit() {
    this.sidebar = <HTMLElement>document.querySelector('.sidebar');
    this.localStorageService.myData$.subscribe(settings => {
      this.settings = settings;
      this.ethAddress = settings?.mainAccount?.ethAddress;
      this.sidebarColor = settings?.sidebarColor;
      this.sidebarActiveColor = settings?.sidebarActiveColor;

      if (this.sidebar != undefined) {
        this.sidebar.setAttribute('data-color', this.sidebarColor);
        this.sidebar.setAttribute('data-active-color', this.sidebarActiveColor);
      }      
    });
  }
  updateAccount() {
    if (!this.settings.mainAccount) {
      this.settings.mainAccount = {} as MainAccount;
    }

    const url = `https://explorer.roninchain.com/api/tokenbalances/${this.ethAddress}`;

    this.httpClient
      .get<any>(url)
      .subscribe((data) => {
        this.settings.mainAccount.eth = parseFloat((data.results[0].balance / 1000000000000000000).toFixed(4));
        this.settings.mainAccount.axs = parseFloat((data.results[2].balance/ 1000000000000000000).toFixed(4));
        this.settings.mainAccount.axies = data.results[3].balance;
        this.settings.mainAccount.slp = data.results[1].balance;

        this.settings.mainAccount.ethAddress = this.ethAddress;
        this.localStorageService.setInfo(this.settings);
      });
  }
}
